// extracted by mini-css-extract-plugin
export default {"spotlight":"Gb1deb1"};